import React from "react";
import { useScrollReveal } from "src/hook/use-scroll-reveal";


// You can create a reusable wrapper component
export function RevealText({ children, className = "", staggerDelay = 0.05 }) {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.2 });

  // This counter ensures delays keep incrementing even across different HTML tags
  let globalWordIndex = 0;

  const processChildren = (child) => {
    // 1. If it's a standard text string, split it into words and spaces
    if (typeof child === "string") {
      // Split by spaces but KEEP the spaces in the array to preserve formatting
      return child.split(/(\s+)/).map((word, index) => {
        if (!word.trim()) return word; // Return spaces as plain text

        const currentIdx = globalWordIndex++;
        
        return (
          <span
            key={`${word}-${currentIdx}`}
            className={`inline-block opacity-0 ${isVisible ? "animate-text-reveal" : ""}`}
            style={{ 
              animationDelay: `${currentIdx * staggerDelay}s`,
              // Will-change optimizes performance for transform animations
              willChange: "transform, opacity" 
            }}
          >
            {word}
          </span>
        );
      });
    }

    // 2. If it's a React Element (like <br/> or <span>)
    if (React.isValidElement(child)) {
      // Don't modify <br /> tags, just return them
      if (child.type === "br") {
        return child;
      }

      // If it's a nested element (like your <span className="font-lora">), 
      // clone it and recursively process ITS children
      return React.cloneElement(child, {
        ...child.props,
        children: React.Children.map(child.props.children, processChildren),
      });
    }

    return child;
  };

  return (
    <div ref={ref} className={className}>
      {React.Children.map(children, processChildren)}
    </div>
  );
}